<template>
    <div>
        <v-container :class="{'pa-0': phoneOnly}">
            <v-card flat class="inbox-wrapper bordered rounded d-flex align-stretch">
                <v-row class="pa-0 ma-0" style="max-width: 100%;">
                    <v-col cols="12" md="5" lg="4" xl="3" class="navigate-aside overflow-y-auto e-scrollbar pa-0 ma-0">
                        <div class="pa-3" style="height: 60px;">
                            <div v-if="showSearch" class="w-100">
                                <v-text-field v-model="searchQuery" autofocus filled flat placeholder="Search..." hide-details dense background-color="grey lighten-4" class="inbox-search" clearable></v-text-field>
                            </div>
                            <div v-else class="w-100 d-flex justify-space-between px-1">
                                <div class="d-flex align-center medium-text font-weight-semibold">
                                    <v-icon color="text">mdi-inbox-full</v-icon>
                                    <div class="ms-1">Inbox</div>

                                    <v-chip v-if="unreadInboxCount" label small color="primary" class="rounded ms-2">{{ unreadInboxCount }}</v-chip>
                                </div>
                                <div>
                                    <v-btn icon outlined @click="showSearch = true;">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </div>

                            </div>
                        </div>
                        <v-divider></v-divider>
                        <v-list two-line color="transparent">
                            <template v-for="conversation in sortedConversations" >
                                <conversation-list-item :key="conversation.id" :conversation="conversation" :active="activeConversation === conversation.id" :disabled="conversationLoading && !(activeConversation === conversation.id)" @open="openConversation(conversation)" />
                                <v-divider inset :key="'d-' + conversation.id" style="border-color: rgba(0,0,0, 0.05)"></v-divider>
                            </template>
                        </v-list>
                        <div v-if="!sortedConversations.length && searchQuery" class="px-3">
                            
                        </div>
                    </v-col>
                    <v-col v-if="pcOnly" cols="12" md="7" lg="8" xl="9" class="pa-0 ma-0">
                        <conversation v-if="activeConversationItem" :conversation="activeConversationItem" style="height: 100%" @loading="updateConversationLoading" />
                        <div v-else class="w-full d-flex flex-column justify-center align-center pb-15" style="height: 100%;">
                            <img src="/img/chat.svg" style="max-width: 400px;" />
                            <div class="mt-4">
                                <h2 class="font-weight-semibold mb-4">Need Help?</h2>
                                <v-btn color="primary" outlined :to="{name: 'help'}">
                                    <v-icon left>mdi-lifebuoy</v-icon>
                                    <span>Contact Us</span>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
            <v-dialog v-if="phoneOnly" v-model="showConversationDialog" transition="slide-left" fullscreen fluid scrollable>
                <v-card flat style="height: 100%" :style="`${iosSafeArea ? 'padding-top: 45px!important; ' : ''}`">
                    <v-toolbar flat style="border-bottom: 1px solid rgba(0,0,0, .1)">

                        <v-btn icon @click="closeConversationDialog" class="ms-0">
                            <v-icon :size="pcOnly ? 21 : 24">mdi-arrow-left</v-icon>
                        </v-btn>
                        <v-toolbar-title v-if="activeConversationItem" class="px-3 medium-text">{{activeConversationItem.title}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <conversation v-if="activeConversationItem" :conversation="activeConversationItem" style="height: 100%" @loading="updateConversationLoading" />
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import ConversationListItem from './conversation-list-item'
import Conversation from './Conversation'

export default {
    name: 'Inbox',
    components: {
        ConversationListItem,
        Conversation,

    },
    data(){
        return {
            activeConversation: null,
            conversationLoading: false,

            showConversationDialog: false,

            
            newMessage: '',
            loading: false,
            
            showSearch: false,
            searchQuery: '',

        };
    },
    computed:{
        ...GlobalComputed,
        activeConversationItem(){
            return this.activeConversation ? this.conversations.find(c=>c.id === this.activeConversation) : null;
        },
        conversations(){
            const conversations = this.$store.state.inboxModule.conversations;
            if (this.searchQuery){
                return conversations.filter(conversation=>{
                    return conversation.title.toLowerCase().search(this.searchQuery.toLowerCase()) !== -1;
                });
            }else{
                return conversations;
            }
        },
        sortedConversations(){
            let conversations = this.conversations;
            conversations = conversations.sort((a, b)=>{
                let aTimestamp = a.last_message ? a.last_message.created_at_timestamp : a.created_at_timestamp;
                let bTimestamp = b.last_message ? b.last_message.created_at_timestamp : b.created_at_timestamp;
                return bTimestamp - aTimestamp;
            });

            return conversations;
        }
    },
    watch: {
        searchQuery(query){
            if (!query && this.showSearch){
                this.showSearch = false;
            }
        },
        loading(loading){
            this.setLinearLoading(loading);
        },
        activeConversation(active){
            if (active){
                this.showConversationDialog = true;
            }
        }
    },
    methods:{
        ...GlobalMethods,
        loadConversations(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getConversations').then(()=>{
                    this.loading = false;
                }).catch(e=>{
                    this.showMsg('Error occurred during preforming your action', 'error');
                    this.loading = false;
                })
            }
        },
        openConversation(conversation){
            if (this.activeConversation !== conversation.id){
                this.activeConversation = conversation.id;
            }else{
                // if clicked on active conversation, mark it as seen
                this.updateSeen(conversation);
            }
        },
        updateConversationLoading(loading){
            this.conversationLoading = loading;
        },
        updateSeen(conversation){
            if (!conversation.seen){
                this.$store.commit('UPDATE_CONVERSATION_DATA', {id: conversation.id, seen: true});
            }
        },
        closeConversationDialog(){
            this.showConversationDialog = false;
            window.setTimeout(()=>{
                this.activeConversation = null;
            }, 500);
        },
        backButtonHandler(){
            if (this.showConversationDialog){
                this.closeConversationDialog();
            }else{
                this.$router.go(-1);
            }
        }
    },
    mounted(){
        this.loadConversations();

        if (this.capRunning){
            document.addEventListener('backbuttonclicked', this.backButtonHandler);
        }
    },
    beforeDestroy(){
        document.removeEventListener('backbuttonclicked', this.backButtonHandler);
    }

}
</script>

<style lang="scss" scoped>
    .inbox-wrapper{
        overflow: hidden;
        @media(min-width: 768px){
            min-height: 80vh;
            max-height: 80vh;
            // box-shadow: 0 1px 1px 0 rgba(#000,.06),0 2px 5px 0 rgba(#000,.2)!important;
        }
        @media(max-width: 768px){
            min-height: 90vh;
        }
        .navigate-aside{
            background-color: #fafafa;
            height: 100%;
            border-right: 1px solid rgba(#000, 0.1);

            .v-list-item--active{
                background: #f1f1f1;
                &::before{
                    opacity: 0;
                }
            }
        }
        .v-toolbar{
            border-bottom: 1px solid rgba(#000, 0.05)!important;
        }
    }
</style>
<style lang="scss">
.inbox-search{
    input{
        padding-top: 5px!important;
        padding-bottom: 5px!important;
    }
}
</style>